import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Eyebrow from './Eyebrow';

// Unified section header with optional right-side action slot
const SectionHeader = ({ eyebrow, title, description, action, align = 'left', white = false, sx = {} }) => {
  const isCenter = align === 'center';
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: isCenter ? 'column' : 'row' },
        justifyContent: isCenter ? 'center' : 'space-between',
        alignItems: { xs: isCenter ? 'center' : 'flex-start', md: 'center' },
        gap: 2,
        textAlign: align,
        mb: { xs: 4, md: 6 },
        ...sx,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        {eyebrow && <Eyebrow white={white}>{eyebrow}</Eyebrow>}
        {title && (
          <Typography
            variant="h2"
            className="serif"
            sx={{ mt: eyebrow ? 1.5 : 0, color: white ? '#fff' : 'var(--ink)' }}
          >
            {title}
          </Typography>
        )}
        {description && (
          <Typography
            variant="body1"
            sx={{ mt: 1.5, fontWeight: 300, maxWidth: 780, color: white ? 'rgba(255,255,255,0.5)' : 'var(--stone)' }}
          >
            {description}
          </Typography>
        )}
      </Box>
      {action && (
        <Box sx={{ flexShrink: 0, alignSelf: { xs: 'flex-start', md: 'center' }, display: 'inline-flex' }}>
          {action}
        </Box>
      )}
    </Box>
  );
};

export default SectionHeader;
